export enum Action {
  Settoken = "SET_TOKEN",
  Setpalylists = "SET_PLAYLISTS",
  Setuserinfo = "SET_USERINFO",
  Set_PLAYLIST = "SET_PLAYLIST",
  Set_PLAYING = "SET_PLAYING",
  Set_PLAYERSTATE = "SET_PLAYERSTATE",
  SetpalylistId = "SetpalylistId",
}
